import { createApp } from 'vue'
import App from './App.vue'
import 'element-plus/dist/index.css' // 基础样式
import '@/styles/index.less'
import { setupStore } from '@/store/store'
import { router, setupGuard } from '@/router'
const app = createApp(App)
setupStore(app)
app.use(router)
setupGuard()
app.mount("#app")